import React from 'react';
import Modal from '@lib/components/common/Modal';
import Button from '../common/Button';
import CustomerFeedbackAPIService from '@lib/api-services/CustomerFeedbackAPIService';
import APIServicesRegistry from '@lib/api-services/APIServicesRegistry';
import Loader from '@lib/components/common/Loader';

export default class CustomerFeedback extends React.Component {
    state = {
        isOpen: false,
        isProcessing: false,
        subject: '',
        body: ''
    }

    constructor(props) {
        super(props)

        scheduleAtDocumentReady(() => {
            this.customerFeedbackAPIService = APIServicesRegistry.getService(CustomerFeedbackAPIService);
        })
    }

    render() {
        return (
            <div>
                <div className="customer-feedback-give-feedback" onClick={() => this.setIsOpen(true)}>Give feedback
                </div>
                <Modal isOpen={this.state.isOpen} onClose={() => this.setIsOpen(false)}>
                    <Modal.Header>{__('Give feedback')}</Modal.Header>
                    <Modal.Body>
                        <div>
                            {this.state.isProcessing && <Loader fillContainer={true}/>}
                            <div className="customer-feedback-field">
                                <label>{__('Subject')}</label>
                                <input onChange={e => this.setSubject(e.target.value)} value={this.state.subject}
                                       type="text"/>
                            </div>
                            <div className="customer-feedback-field">
                                <label>{__('Body')}</label>
                                <textarea onChange={e => this.setBody(e.target.value)} value={this.state.body}
                                          rows="5"/>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button theme={Button.Theme.BorderOnly}
                                onClick={() => this.onCloseButtonClick()}>{__('Close')}</Button>
                        <Button disabled={!this.isValid()}
                                onClick={() => this.onSendButtonClick()}>{__('Send')}</Button>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }

    setIsOpen = (value) => {
        this.setState({isOpen: value})
    }

    setSubject = (value) => {
        this.setState({subject: value})
    }

    setBody = (value) => {
        this.setState({body: value})
    }

    onCloseButtonClick = () => {
        this.setState({
            isOpen: false,
            subject: '',
            body: ''
        })
    }

    onSendButtonClick = () => {
        let data = {
            subject: this.state.subject.trimStart(),
            body: this.state.body
        };

        let send = () => {
            this.customerFeedbackAPIService.sendCustomerFeedback(data).then(() => {
                this.setState({
                    isOpen: false,
                    isProcessing: false,
                    subject: '',
                    body: ''
                })
            }).catch(() => {
                this.setState({
                    isProcessing: false
                })
            });
        }

        this.setState({
            isProcessing: true
        }, () => {
            send()
        })
    }

    isValid = () => {
        if (this.state.subject.trimStart() == '' || this.state.body.trimStart() == '') {
            return false;
        }

        return true;
    }
}

window.components.CustomerFeedback = CustomerFeedback